// Dark mode composable for global theme management
import { reactive, watch, computed } from 'vue'

// Global state for dark mode
const darkModeState = reactive({
  isDarkMode: false
})

// Load dark mode preference from localStorage on app start
const loadDarkModePreference = () => {
  const savedPreference = localStorage.getItem('darkMode')
  darkModeState.isDarkMode = savedPreference === 'true'
}

// Save dark mode preference to localStorage
const saveDarkModePreference = (isDark) => {
  localStorage.setItem('darkMode', isDark.toString())
}

// Toggle dark mode function
const toggleDarkMode = () => {
  darkModeState.isDarkMode = !darkModeState.isDarkMode
  saveDarkModePreference(darkModeState.isDarkMode)
}

// Watch for changes and save to localStorage
watch(() => darkModeState.isDarkMode, (newValue) => {
  saveDarkModePreference(newValue)
})

// Composable function to use in components
export const useDarkMode = () => {
  return {
    isDarkMode: computed(() => darkModeState.isDarkMode),
    toggleDarkMode,
    loadDarkModePreference
  }
}

// Initialize dark mode on app start
loadDarkModePreference()

export { darkModeState }